import { simulateWeek } from '../simulation/simulateWeek';
import { createResearchOpportunity, quizThreshold } from './quizFlow';
import type { GameState } from './types';

/**
 * 计算“下一周”的纯函数：单人模式（GameContext）与联机服务端（Durable Object
 * 守护程序）共用，保证两种模式下推进结果一致。
 *
 * 返回新状态；若当前不允许推进（已结束 / 拍卖中），原样返回。
 */
export function computeAdvancedWeek(state: GameState): GameState {
  if (state.gameOver) return state;
  if (state.activeAuction) return state;
  const next = simulateWeek(state);
  const activeRouteCount = next.routes.filter((route) => route.active).length;
  const lastQuizWeek = next.lastQuizWeek ?? 0;
  const weeksSinceQuiz = next.week - lastQuizWeek;
  const existingOpportunity = next.researchOpportunity;
  if (existingOpportunity && existingOpportunity.expiresWeek < next.week) {
    next.researchOpportunity = undefined;
  }
  if (next.quizModeEnabled !== false && next.week >= 12 && activeRouteCount > 0 && weeksSinceQuiz >= quizThreshold(next.week) && !next.researchOpportunity) {
    return { ...next, quizCounter: 0, researchOpportunity: createResearchOpportunity(next), pendingQuiz: false };
  }
  return { ...next, quizCounter: state.quizCounter + 1 };
}
